const wheelSubjectAssess = {
  tableConfig: {
    // showCheckbox: true
  },
  queryList: [
    {
      name: 'roundNum',
      label: '轮次',
      component: 'select',
      componentAttr: {
        options: [{
          value: 3,
          label: '第三轮'
        }, {
          value: 4,
          label: '第四轮'
        }]
      }
    },
    {
      name: 'subjectLevel',
      label: '等级',
      component: 'select',
      componentAttr: {
        options: [{
          value: 1,
          label: 'A'
        }, {
          value: 2,
          label: 'A+'
        }, {
          value: 3,
          label: 'A-'
        }, {
          value: 4,
          label: 'B'
        }, {
          value: 5,
          label: 'B+'
        }, {
          value: 6,
          label: 'B-'
        }]
      }
    },
    {
      name: 'workCode',
      label: '单位代码',
      component: 'input'
    },
    {
      name: 'workName',
      label: '单位名称',
      component: 'input'
    },
    {
      name: 'subjectCode',
      label: '学科代码',
      component: 'input'
    },
    {
      name: 'subjectName',
      label: '学科名称',
      component: 'input'
    },
    {
      name: 'cityName',
      label: '省市',
      component: 'input'
    },
    {
      name: 'subjectKind',
      label: '学科门类',
      component: 'input'
    }
  ],
  urlMap: {
    'select': 'school/schoolSubjectAccess/list'
  },
  operList: [// 操作列表
    // {
    //   name: 'importTemplate',
    //   label: '导入',
    //   show: true,
    //   action: {
    //     type: 'dialog',
    //     footerHide: true,
    //     addr: 'uploadFile',
    //     prop: {
    //       url: '/school/schoolSubjectAccess/importUserExportConfig'
    //     }
    //   }
    // }
    {
      name: 'importTemplate',
      label: '导入',
      show: true,
      action: {
        type: 'dialog',
        footerHide: true,
        addr: 'systemManage/uploadFunds'
      }
    }
  ],
  titles: [
    {
      name: 'subjectLevel',
      label: '等级'
    },
    {
      name: 'workCode',
      label: '单位代码'
    },
    {
      name: 'workName',
      label: '单位名称'
    },
    {
      name: 'subjectCode',
      label: '学科代码'
    },
    {
      name: 'subjectName',
      label: '学科名称'
    },
    {
      name: 'cityName',
      label: '省市'
    },
    {
      name: 'subjectKind',
      label: '学科门类'
    }
  ]
}
export default wheelSubjectAssess



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/subjectAssess/wheelSubjectAssess.js